import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";
import { LoginComponent } from "./login.component";
import { ResetPasswordComponent } from "./resetpassword.component";
import { NgxLoadingModule } from "ngx-loading";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatInputModule,
    MatCardModule,
    NgxLoadingModule,
  ],
  declarations: [LoginComponent, ResetPasswordComponent],
  exports: [LoginComponent, ResetPasswordComponent],
})
export class LoginModule {}
